export const TABS = {
  MAIN: "main",
  SUMMARIES: "summaries",
  HELP: "help",
}

// Constants representing different AiMS availability and behavior statuses
export const AIMS_STATUS = {
  // AiMS is available for this meeting, both the organizer and attendees will receive the summary
  AVAILABLE: "AimsAvailable",

  // AiMS is partially available, only the organizer will receive the summary
  SUMMARY_TO_ORGANIZER: "SummaryToOrganizer",

  // AiMS is not available for this meeting (e.g., due to legal policy)
  NOT_AVAILABLE: "AimsNotAvailable",

  // The meeting has external attendee
  EXTERNAL_ATTENDEE: "ExternalAttendee",

  // AiMS failed due to an unexpected error (could be from frontend or backend)
  EXCEPTION: "AimsException",
};

export const AIMS_NOT_AVAILABLE_MESSAGE = {
  DEFAULT: "Not all meetings are approved for Amazon Meetings Summary.",
  PERFORMANCE: "The meeting subject indicates complaints, investigations or performance discussions.",
  REGIONS: "Some attendees are from regions where Amazon Meetings Summary isn’t yet available.",
};

export const TRANSCRIPT_START_CHAT_MESSAGE = 'The meeting organizer has enabled AiMS meeting summaries. By participating in this meeting, you understand that Amazon is briefly transcribing and analyzing your voice audio and communications on Zoom to summarize the call.';

export const ROLES = {
  ORGANIZER: "organizer",
  ALTERNATIVE_HOST: "alternativeHost",
  ATTENDEE: "attendee",
};
